import { graphqlClient } from '../../graphql/graphql'
import { CREATE_AFFILIATION, MIGRATE_AFILIATES } from '../../graphql/mutations/affiliation'
import { FETCH_USER_AFFILIATIONS, FETCH_ORGANIZATION_AFFILIATIONS } from '../../graphql/queries/affiliation'

/**
 * Función para crear una orden de una afiliación
 * @param { Object } order Objecto de la orden generado en el checkout de afiliación.
 */
export const createAffiliation = async ({ commit }, order) => {
    let { data: { createAffiliation: { id } } } = await graphqlClient.mutate({
        mutation: CREATE_AFFILIATION(order)
    })
    return id
}
/**
 * Función para migrar afiliados desde la vista de administrador
 * @param { Array<Object> } dataAffiliates Arreglo de objetos de afiliados obtenidos del CSV de afiliados
 */
export const migrateAffiliations = async ({ commit }, dataAffiliates) => {
    let data = await graphqlClient.mutate({
        mutation: MIGRATE_AFILIATES(dataAffiliates)
    })
    return data
}

/**
 * Función que obtiene las afiliaciones que tiene un usuario de tipo afiliado.
 */
export const fetchAffiliations = async ({ commit }) => {
    let { data: { affiliateAffiliations } } = await graphqlClient.query({
        query: FETCH_USER_AFFILIATIONS,
        fetchPolicy: 'network-only'
    })
    commit('setUserAffiliationInformation', affiliateAffiliations)
}

/**
 * Función que obtiene todas las afiliaciones y transacciones de afiliaciones de una organización.
 */
export const fetchOrganizationAffiliations = async ({ commit }) => {
    let { data: { organizationAffiliations } } = await graphqlClient.query({
        query: FETCH_ORGANIZATION_AFFILIATIONS,
        fetchPolicy: 'network-only'
    })
    commit('setOrganizationAffiliations', organizationAffiliations)
}

